import { createAction } from 'redux-actions';

export const DETECT_THEME = 'DETECT_THEME';

export const detectTheme = createAction('DETECT_THEME', (theme) => {
  return theme;
});
